import { useAuthBearerFetch } from "matsuri-hooks"
import { m2mCleaning_cleanerV3 } from "@/endpoints/m2m-cleaning.cleaner-v3"

export interface OperationAttachmentImage {
    id: string
    cleaningId: string
    imageUrl: string
}

interface UseOperationAttachmentImageOutput {
    images: OperationAttachmentImage[]
}

export const useOperationAttachmentImage = (
    token: string,
    operationId: string
) => {
    const endpoint =
        m2mCleaning_cleanerV3.findOparationAttachmentImagesForCleaner

    return useAuthBearerFetch<UseOperationAttachmentImageOutput>(
        token,
        endpoint({ cleaningId: operationId }),
        {
            method: endpoint.method
        }
    )
}
